<template>
  <div
    v-if="!isInIframe || !isLoggedIn"
    id="app"
  >
    <!-- Loader starts-->
    <div
      class="loader-wrapper"
      :class="{'loderhide' : !show }"
    >
      <div class="loader bg-white">
        <div class="whirly-loader" />
      </div>
    </div>
    <!-- Loader ends-->

    <!--<Main/>-->
    <router-view />
  </div>
  <div
    v-else
    id="app"
    class="d-flex justify-content-center align-items-center vh-100"
    style="background: linear-gradient(to bottom, blue, white);"
  >
    <div>
      <button
        class="btn btn-primary btn-lg"
        @click.prevent="redirectToDashboard"
      >
        Sayta keçin
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      show: true
    }
  },
  computed: {
    isInIframe() {
      return window !== window.top;
    },
    isLoggedIn() {
      return !!localStorage.getItem("token");
    }
  },
  mounted() {
      this.timeOut();
    },
    methods:{
      redirectToDashboard() {
        window.open('/dashboard/welcome', '_blank');
      },
      timeOut(){
            var self = this;
            setTimeout(function(){
                self.show = false;
            }, 1000);
      }
     }
  }
</script>


<style lang="scss">
.loader-wrapper.loderhide {
  display: none;
}
.centered-container {
  text-align: center;
}
.full-page-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, blue, white); /* Gradient background */
}


.blur {
    -webkit-filter: blur(5px);
    -moz-filter: blur(5px);
    -o-filter: blur(5px);
    -ms-filter: blur(5px);
    filter: blur(5px);
}


@keyframes blink {
  50% {
    opacity: 0.2;
  }
}

@-webkit-keyframes blink {
  50% {
    opacity: 0.2;
  }
}

.blink {
  animation: blink 1s step-start 0s infinite;
  -webkit-animation: blink 1s step-start 0s infinite;
}

.pointer{
  cursor: pointer !important;
}
.cursor-pointer{
  cursor: pointer !important;
}

.form-control{
  background: rgba(#DEE5EF,0.33) !important;
  border-color: rgba(#DEE5EF,0.5) !important;
  border-radius: 6px !important;
}

.input-group-prepend{
  background: rgba(#DEE5EF,0.33) !important;
  border-color: rgba(#DEE5EF,0.5) !important;
  border-radius: 6px 0 0 6px !important;
}

.input-tel__input{
  background: rgba(#DEE5EF,0.33) !important;
  border-color: rgba(#DEE5EF,0.5) !important;
  border-radius: 0 6px 6px 0 !important;
}

.country-selector__input{
  background: rgba(#DEE5EF,0.33) !important;
  border-color: rgba(#DEE5EF,0.5) !important;
  border-radius:  6px 0 0 6px !important;
}

.rounded {
  border-radius: 6px !important;
}

h4 {
  font-size: 18px !important;
  font-weight: bold !important;
}


.card {
  .card-body {
    padding: 40px;
    font-size: 14px;
    color: #5D6B82;

    h4 {
      font-size: 16px !important;
      color: #233656;
    }

    p {
      font-size: 14px;
    }

    label {
      color: #233656;
    }
  }
  &.bg-primary {
    color: white !important;
    h4, p, label, div {
      color: #fff;
    }
  }
  .back-circle{
    background: #F5F7FA;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &.small{
      width: 25px;
      height: 25px;
    }
  }
}


</style>
